import { render, staticRenderFns } from "./BuildingsView.vue?vue&type=template&id=9bee7cce"
import script from "./BuildingsView.vue?vue&type=script&lang=js"
export * from "./BuildingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports